export default __webpack_public_path__ + "static/media/businesses.bbc2ed46.png";